import DOMPurify from 'dompurify';
import { useMemo, useState, CSSProperties } from 'react';

interface DataImageProps {
  fileType: string;
  fileContent: string;
  style?: CSSProperties;
  className?: string;
  filename?: string;
}

const ImageFallback = () => <i className="fa-regular fa-image" />;

const DataImage = ({ fileType, fileContent, style, className, filename }: DataImageProps) => {
  const [error, setError] = useState(false);

  const cleanData = useMemo(() => {
    if (fileType === 'image/svg+xml') {
      const sanitized = DOMPurify.sanitize(atob(fileContent));
      // Remove width and height attributes
      let svgTag = sanitized.substring(0, sanitized.indexOf('>') + 1);
      const svgContent = sanitized.substring(sanitized.indexOf('>') + 1);
      svgTag = svgTag?.replace(/width="[^"]*"/, 'width="100%"')?.replace(/height="[^"]*"/, 'height="auto"');

      // Add viewBox if missing to enable responsiveness
      if (!svgTag.includes('viewBox')) {
        svgTag = svgTag.replace('<svg ', '<svg viewBox="0 0 24 24" ');
      }
      return `data:image/svg+xml;base64,${btoa(svgTag + svgContent)}`;
    } else {
      return `data:${fileType};base64,${fileContent}`;
    }
  }, [fileContent, fileType]);

  if (error) return <ImageFallback />;

  return <img src={cleanData} style={style} className={className} alt={filename} onError={() => setError(true)} />;
};

export default DataImage;
